export interface NumberValidatorOptions {
    step: number; // Must be positive
    min?: number;
    max?: number;
}

export class NumberValidator {
    private readonly EPS = 0.00000001;

    constructor(private options: NumberValidatorOptions) {
        if (this.options.step < 0) {
            throw "Step must be positive";
        }

        if (this.options.step < this.EPS) {
            throw "Step is too small";
        }
    }

    public isValid(value: number): boolean {
        return (this.options.min === undefined || value >= this.options.min) && (this.options.max === undefined || value <= this.options.max) && this.valueValidForStep(value);        
    }

    private valueValidForStep(value: number) {
        const remainder = Math.abs(value % this.options.step);

        // We're expecting the remainder to be either 0, a number very close to zero, or a number very close to the step.
        return remainder === 0 || remainder < this.EPS || Math.abs(this.options.step - remainder) < this.EPS;
    }    
}